export const navigation = [
  {
    name: 'Inicio',
    url: '/dashboard',
    icon: 'icon-home',
    badge: {
      //variant: 'info',
      //text: 'NEW'
    }
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'Documentación Programa'
  },
  {
    name: 'Guía IMPLANTA',
    icon: 'fa fa-file-pdf-o',
    idconvocatoria: '4',
    idtipodocumentacion:'3'
  },
  {
    name: 'Cuestionario Implanta',
    icon: 'fa fa-file-word-o',
    idconvocatoria: '4',
    idtipodocumentacion:'2'
  },
  {
    name: 'Anexo Seguimiento',
    icon: 'fa fa-file-pdf-o',
    idtipodocumentacion:'4',
    idconvocatoria: '5',
  },
  {
    name: 'Cuestionario Seg.',
    icon: 'fa fa-file-word-o',
    idconvocatoria: '5',
    idtipodocumentacion:'2'
  },
  {
    divider: true
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'SEGUIMIENTO'
  },
  {
    name: 'Expedientes',
    url: '/expedientes/2',
    icon: 'fa fa-table',

  },
  {
    name: 'Convocatorias',
    url: '/convocatorias/nueva/2',
    icon: 'fa fa-table',
    badge: {
      variant: '',
      text: ''
    }
  },
  {
    divider: true
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'IMPLANTA'
  },
  {
    name: 'Expedientes',
    url: '/expedientes/1',
    icon: 'fa fa-table',
    badge: {
      variant: '',
      text: ''
    }
  },
  {
    name: 'Convocatorias',
    url: '/convocatorias/nueva/1',
    icon: 'fa fa-table',
    badge: {
      variant: '',
      text: ''
    }
  },
  // {
  //   divider: true
  // },
  // {
  //   divider: true
  // },
  // {
  //   title: true,
  //   name: 'EVALUADORES'
  // },
  // {
  //   name: 'Evaluadores',
  //   url: '/expedientes/1',
  //   icon: 'fa fa-table',
  //   badge: {
  //     variant: '',
  //     text: ''
  //   }
  // },
  // {
  //   name: 'Comisiones',
  //   url: '/convocatorias/nueva/1',
  //   icon: 'fa fa-table',
  //   badge: {
  //     variant: '',
  //     text: ''
  //   }
  // }  



];


export const navigationEvaluador = [
  {
    name: 'Inicio',
    url: '/dashboard',
    icon: 'icon-home',
    badge: {
      //variant: 'info',
      //text: 'NEW'
    }
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'Documentación Programa'
  },
  {
    name: 'Guía IMPLANTA',
    icon: 'fa fa-file-pdf-o',
    idconvocatoria: '4',
    idtipodocumentacion:'3'
  },
  {
    name: 'Cuestionario Implanta',
    icon: 'fa fa-file-word-o',
    idconvocatoria: '4',
    idtipodocumentacion:'2'
  },
  {
    name: 'Anexo Seguimiento',
    icon: 'fa fa-file-pdf-o',
    idtipodocumentacion:'4',
    idconvocatoria: '5',
  },
  {
    name: 'Cuestionario Seg.',
    icon: 'fa fa-file-word-o',
    idconvocatoria: '5',
    idtipodocumentacion:'2'
  },
  {
    divider: true
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'SEGUIMIENTO'
  },
  {
    name: 'Expedientes',
    url: '/expedientes/2',
    icon: 'fa fa-table',

  },
  {
    divider: true
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'IMPLANTA'
  },
  {
    name: 'Expedientes',
    url: '/expedientes/1',
    icon: 'fa fa-table',
    badge: {
      variant: '',
      text: ''
    }
  }



];


export const navigationUniversidad = [
  {
    name: 'Inicio',
    url: '/dashboard',
    icon: 'icon-home',
    badge: {
      //variant: 'info',
      //text: 'NEW'
    }
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'Documentación Programa'
  },
  {
    name: 'Anexo Seguimiento',
    icon: 'fa fa-file-pdf-o',
    idtipodocumentacion:'4',
    idconvocatoria: '5',
  },
  {
    name: 'Modelo Autoinforme',
    icon: 'fa fa-file-word-o',
    idtipodocumentacion:'5',
    idconvocatoria: '5',
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'SEGUIMIENTO'
  },
  {
    name: 'Expedientes',
    url: '/expedientes/2',
    icon: 'fa fa-table',

  }


];



// WEBPACK FOOTER //
// /app/src/app/_nav.ts